import React from 'react';

function Footer() {
    return (
        <footer className="shadow-2xl bg-gradient-to-b from-[#1a3325] to-[#0f2119] h-100 p-10">
            <section>
                <div className="text-md-start">
                    <div className="row">
                        <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                            <h6 className="text-uppercase text-transparent bg-clip-text bg-gradient-to-r from-[#fff] to-[#9fc4ac] fw-bold mb-2">
                                Socials
                            </h6>
                            <a target="_blank" rel="noreferrer" href="https://x.com/peticle_app">
                                <i className="fa fa-twitter me-3 text-white"></i>
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/peticle.app">
                                <i className="fa fa-instagram me-3 text-white"></i>
                            </a>
                        </div>

                        <div className="text-transparent bg-clip-text bg-gradient-to-r from-[#fff] to-[#9fc4ac] col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-1">
                            <h6 className="text-uppercase fw-bold mb-2">Contact</h6>
                            <p>
                                <i className="fa fa-envelope me-3 text-white"></i>
                                hello@unit326.com
                            </p>
                        </div>

                        <div className="text-transparent bg-clip-text bg-gradient-to-r from-[#fff] to-[#9fc4ac] col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-1">
                            <h6 className="text-uppercase fw-bold mb-2">Legal</h6>
                            <p>
                                <a href="/privacy-policy" className="text-[#9fc4ac] hover:text-white">Privacy Policy</a>
                            </p>
                            <p>
                                <a href="/data-settings" className="text-[#9fc4ac] hover:text-white">Data Settings</a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <hr className="text-white opacity-20" />
            <div className="text-center text-transparent bg-clip-text bg-gradient-to-r from-[#fff] to-[#9fc4ac] p-4">
                © 2026 Peticle. All rights reserved.
            </div>
        </footer>
    );
}

export default Footer;
